import React, { useRef, useState, useEffect, useCallback } from 'react';
import {Container, Row, Col, Form} from 'react-bootstrap';
import { useNavigate, useLocation} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { ERROR_MESSAGES } from '../../data/LoginPageConstants.js';
import { ValidationService } from '../../utils/Auth.js';
import { Header } from '../header/header.js';
import Userlist from '../userList/UserList.js';

import './InitialLogin.css'
import { Formik} from 'formik';
import { AUTH_STATE_PASS, AUTH_STATE_PIN } from '../../data/GlobalConstants.js';
import jugador1 from '../../assets/images/RBB_2025_SSO_jugador1.png';
import jugador3 from '../../assets/images/RBB_2025_SSO_jugador3.png';

import background1 from '../../assets/images/RBB_2025_SSO_fondo_v1.jpg';
import background2 from '../../assets/images/RBB_2025_SSO_fondo_v2.jpg';
import background3 from '../../assets/images/RBB_2025_SSO_fondo_v3.jpg';




async function validation(token) {
    return await ValidationService.verifyJWT(token)
}

// Añadir este nuevo esquema
const initialLoginSchema = yup.object().shape({
    id: yup.string()
        .required(ERROR_MESSAGES.emptyField)
        .test('format', ERROR_MESSAGES.invalidFormat, (value) => {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const numericIdRegex = /^[0-9]+$/;
            return emailRegex.test(value) || numericIdRegex.test(value);
        })
});

function LoginPage() {
    const [authType, setAuthType] = useState('')
    const [error, setError] = useState('');
    const [url, setURL] = useState('');
    const [dynamicURL, setDynamicURL] = useState('');
    const navigate = useNavigate()
    const [lenguage, setLanguage] = useState('es');
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [members, SetMembers] = useState(null)
    const [isValidating, setIsValidating] = useState(true);
    const [loginPin, setLoginPin] = useState(false);
    const [tokenReload, setTokenReload] = useState(true);
    const [pinPass, setPinPass] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [activeTab, setActiveTab] = useState('signin');
    const [randomPlayer, setRandomPlayer] = useState(null);
    const [randomBackground, setRandomBackground] = useState(null);

    const formRef = useRef();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const status = queryParams.get('status');
    const dynamicURLParam = queryParams.get('dynamicURL');
    const singUpURL = queryParams.get('singUpURL');
    const memberTypeParam = queryParams.get('memberType');


    const handlePin = () => {
        setLoginPin(true);
        setTokenReload(false);
        setPinPass(true);
        setAuthType(AUTH_STATE_PIN);
    };

    const handlePass = () => {
        setLoginPin(false);
        setTokenReload(false);
        setPinPass(true);
        setAuthType(AUTH_STATE_PASS);
    };

    const detectInputType = (value) => {
        // Regex para validar email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // Regex para validar ID numérico
        const numericIdRegex = /^[0-9]+$/;

        if (emailRegex.test(value)) {
            // Es un email, cambiar a modo de contraseña
            handlePass();
            return 'pass';
        } else if (numericIdRegex.test(value)) {
            // Es un ID numérico, cambiar a modo de PIN
            handlePin();
            return 'pin';
        }
        
        // No es ninguno de los patrones válidos
        return false;
    };

    const onChangeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    if (token && tokenReload) {
        validation(token).then( data => {
            setIsValidating(true);
            setAuthType(data.payload.type);
            setURL(data.payload.retURL);
            setIsValidating(false);
        }).catch( e => {
            setIsValidating(false);
        })
        setTokenReload(false);
    }

    
    const handleNext = async () => {
        var values = formRef.current.values;

        const inputType = detectInputType(values.id);
        if (!inputType) {
            setError(ERROR_MESSAGES.invalidFormat)
            return;
        } else {
            // Guardar el ID en localStorage
            localStorage.setItem('user_id', values.id);
            const params = new URLSearchParams();
            if (token) params.append('token', token);
            if (dynamicURLParam) params.append('dynamicURL', dynamicURLParam);
            if (memberTypeParam) params.append('memberType', memberTypeParam);
            if (singUpURL) params.append('singUpURL', singUpURL);
            if (status) params.append('status', status);

            // Construimos la URL base con los parámetros
            const queryString = params.toString();
            
            if (inputType === 'pin') {
                window.location.href = `/login/pin?${queryString}`;
            } else {
                window.location.href = `/login/pass?${queryString}`;
            }
        }
    }

    const handleRegister = () => {
        if (memberTypeParam) {
            window.location.href = `https://socios.realbetisbalompie.es/socios/membresia/${memberTypeParam}/registro`;
        } else {
            window.location.href = `https://socios.realbetisbalompie.es/socios/membresia/registro`;
        }
    };

    const selectRandomPlayer = useCallback(() => {
        const players = [jugador1, jugador3];
        return players[Math.floor(Math.random() * players.length)];
    }, []);

    const selectRandomBackground = useCallback(() => {
        const backgrounds = [background1, background2, background3];
        return backgrounds[Math.floor(Math.random() * backgrounds.length)];
    }, []);

    useEffect(() => {
        setRandomPlayer(selectRandomPlayer());
        setRandomBackground(selectRandomBackground());
    }, [selectRandomPlayer, selectRandomBackground]);

    return (
        <Container fluid className="componentFather">
            <Header setLanguage={onChangeLanguage} />
            <div className='bg-composition thaklok' style={{ backgroundImage: `url(${randomBackground})` }}>
                {randomPlayer && <img src={randomPlayer} alt="Jugador Real Betis Balompie" />}
            </div>
            <div className='content-container'>

            <div className="auth-tabs-container">
                <div className="auth-tabs">
                    <button 
                        className={`tab-button ${activeTab === 'signin' ? 'active' : ''}`}
                        onClick={() => setActiveTab('signin')}
                    >
                        {t('signIn')}
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'register' ? 'active' : ''}`}
                        onClick={handleRegister}
                    >
                        {t('signUp')}
                    </button>
                </div>
            </div>
                <Row className="px-4 my-5 formLogin">
                    <Col sm={4}>
                    {status && <div className="sendedPin mb-3">{t('resetPass')}</div>}
                        <Container className="mt-5">
                        {members && <Userlist members={members} url={url} />}
                        </Container>
                        {!members && <Formik
                        validationSchema={initialLoginSchema}
                        onSubmit={handleNext}
                        validateOnChange={false}
                        innerRef={formRef}
                        initialValues={{
                            id: '',
                        }}
                        >
                        {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            values,
                            touched,
                            isValid,
                            errors,
                        }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            {isLoading && <div class="loader mb-3"></div>}
                            {error && <div className="errorPin">
                                {
                                    t('invalidAuth')
                                }
                            </div>}
                            
                            <Form.Group className="mb-3 position-relative">
                                <Form.Label className="fit">{t('initialLoginInput')}</Form.Label>
                                <Form.Control type="text" placeholder=""  className="aditionalInfo"
                                    name="id" value={values.id} onChange={(e) => {
                                        e.target.value = e.target.value.toLowerCase();
                                        handleChange(e);
                                    }} isInvalid={!!errors.id} />
                                <Form.Control.Feedback  className="error" type="invalid" tooltip>
                                    {t('emptyField')}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <button type="submit" className="btnLogin"
                                onClick={handleNext}>{t('buttonNext')}
                            </button>
                            <button type="button" className="btnRecover"
                                    onClick={() => { navigate(`/forgotpin?token=${token}`, {state: AUTH_STATE_PASS }) }}>{t('forgotPassword')}
                            </button>
                        </Form>
                        )}
                        </Formik>
                    }
                    </Col>
                </Row>
            </div>
            <button type="button" className="btnBack"
                onClick={handleRegister}>{t('noAccount')}
            </button>
        </Container>
    )
    // } else {
    //     return(
    //         <div>
    //             {isValidating && <div className="loader mt-5"></div>}
    //             {!isValidating && <ErrorPage />}
    //         </div>
    //     )
    // }
}

export default LoginPage;